var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"flex flex-col justify-between",class:{
    'rounded-md border border-slate-400': _vm.showBorder
  }},[(_vm.title || _vm.$slots.controls || _vm.$slots.title)?_c('div',{staticClass:"grid grid-cols-1 gap-2",class:{
      'md:grid-cols-2 md:gap-0 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5': _vm.fullWidth,
      'xl:grid-cols-2 xl:gap-0': !_vm.fullWidth,
      'border-b border-slate-400 px-4': _vm.showBorder,
      'py-2': _vm.$slots.controls && _vm.showBorder && !_vm.headerSpacingClass,
      'py-3': !_vm.$slots.controls && _vm.showBorder && !_vm.headerSpacingClass,
      'pb-2 pt-0': _vm.$slots.controls && !_vm.showBorder && !_vm.headerSpacingClass,
      'pb-3 pt-0': !_vm.$slots.controls && !_vm.showBorder && !_vm.headerSpacingClass,
      [_vm.headerSpacingClass]: _vm.headerSpacingClass
    }},[_c('div',{staticClass:"col-span-full text-vanilla-100",class:{
        'sm:col-span-1 md:col-span-1 xl:col-span-2': _vm.fullWidth && _vm.$slots.controls,
        'xl:col-span-1': !_vm.fullWidth && _vm.$slots.controls
      }},[_vm._t("title",function(){return [_c('div',{staticClass:"flex h-full items-center space-x-2"},[_c('span',{staticClass:"text-base font-semibold tracking-snug"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.helpText)?_c('z-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.helpText, delay: { show: 0, hide: 100 } }),expression:"{ content: helpText, delay: { show: 0, hide: 100 } }"}],staticClass:"flex-shrink-0 stroke-1.5 transition-opacity duration-75",attrs:{"icon":"help","color":"vanilla-400"}}):_vm._e()],1)]})],2),_vm._v(" "),(_vm.$slots.controls)?_c('div',{staticClass:"col-span-full",class:{
        'md:col-span-2 xl:col-span-2 2xl:col-span-3': _vm.fullWidth,
        'xl:col-span-1': !_vm.fullWidth
      }},[_vm._t("controls")],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex-grow",class:{
      'p-0': !_vm.spacingClass && _vm.bodySpacing === 0,
      'p-2': !_vm.spacingClass && _vm.bodySpacing === 2,
      'p-4': !_vm.spacingClass && _vm.bodySpacing === 4,
      'gap-0': _vm.gridGap === 0,
      'gap-2': _vm.gridGap === 2,
      'gap-4': _vm.gridGap === 4,
      'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5':
        _vm.bodyIsGrid && !_vm.customGridClass,
      [_vm.customGridClass]: _vm.customGridClass && _vm.bodyIsGrid,
      [_vm.spacingClass]: _vm.spacingClass
    }},[_vm._t("default")],2),_vm._v(" "),_c('div',[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }